import { IDropdownOption } from 'Src/ng2/shared/typings/interfaces/design-library.interface';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'nv-dropdown',
  template: require('./nv-dropdown.component.html'),
  styles: [require('./nv-dropdown.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NvDropdownComponent {
  /**
   *
   * The key of the selected option
   */
  @Input() selected: string;

  /**
   *
   * An array of `IDropdownOptions`.
   *
   * Each option can have its own options attribute
   *
   * ```
   * interface IDropdownOption {
   *  key: string,
   *  human: string,
   *  options?: Array<IDropdownOption>
   * }
   * ```
   *
   */
  @Input() options: IDropdownOption[];

  /**
   *
   * Temporary prop to return either a IACOption or string
   *
   * When refactoring, this should be always true
   */
  @Input() returnObject: boolean = false; // TODO -  REMOVE THIS ON REFACTOR - AT

  /**
   *
   * The text inside the pill when there is no `selected` option
   *
   * Required when no `selected` prop is given
   */
  @Input() placeholder: string;

  /**
   *
   * Sets the text to `color`, and the background to a light version of `color`
   */
  @Input() isInverted: boolean = false;

  /**
   *
   * The event emited when an option is selected.
   *
   * Returns the key of the selected `IDropdownOption`
   *
   */
  @Output() selectOption: EventEmitter<IDropdownOption | string> = new EventEmitter<IDropdownOption | string>();

  public parentOfSelected: string;

  ngOnInit(): void {
    this.parentOfSelected = this.getParentOfSelection(this.selectedOption, this.options);
  }

  get selectedOption(): IDropdownOption {
    return this.getOptionFromKey(this.selected, this.options);
  }

  get pillLabel(): string {
    return this.selectedOption ? this.selectedOption.human : this.placeholder;
  }

  handleSelectSuboption(option: IDropdownOption) {
    this.parentOfSelected = this.getParentOfSelection(option, this.options);
    this.selected = option.key;
    const emitVal = this.returnObject ? option : option.key;
    this.selectOption.emit(emitVal);
  }

  getOptionFromKey(searchKey: string, searchOptions: IDropdownOption[]): IDropdownOption {
    let foundOption: IDropdownOption = null;
    if (!!searchKey) {
      for (const opt of searchOptions) {
        if (!!foundOption) {
          break;
        } else if (opt.options) {
          foundOption = this.getOptionFromKey(searchKey, opt.options);
        } else if (opt.key === searchKey) {
          foundOption = opt;
        }
      }
    }
    return foundOption;
  }

  isCurrentSelected(option: IDropdownOption): boolean {
    return option.key === this.selected;
  }

  trackByFn(_: number, { key }) {
    return key;
  }

  getParentOfSelection(selectedOption: IDropdownOption, allOptions: IDropdownOption[]): string {
    return allOptions.reduce((parent: string, { options: suboptions, key }) => {
      if (suboptions && suboptions.includes(selectedOption)) parent = key;
      return parent;
    }, null);
  }
}
